'use client';

/**
 * Mode selector for practice. Modes without sufficient data are hidden.
 * @param {{
 *   mode: string,
 *   onChange: (m: string) => void,
 *   hasWeakKeys: boolean,
 * }} props
 */
export function PracticeModePicker({ mode, onChange, hasWeakKeys }) {
  const modes = [
    { id: 'free', label: 'Free typing' },
    { id: 'timed', label: 'Timed' },
    { id: 'common', label: 'Common words' },
    { id: 'custom', label: 'Custom text' },
    { id: 'weak', label: 'Weak keys', disabled: !hasWeakKeys },
  ];

  return (
    <div className="flex flex-wrap gap-2">
      {modes.map((m) => (
        <button
          key={m.id}
          type="button"
          onClick={() => !m.disabled && onChange(m.id)}
          disabled={m.disabled}
          aria-pressed={mode === m.id}
          className={`rounded-md border px-3 py-1.5 text-sm font-medium transition-colors ${
            mode === m.id
              ? 'border-brand-600 bg-brand-600 text-white'
              : m.disabled
                ? 'cursor-not-allowed border-border text-text-muted opacity-50'
                : 'border-border bg-surface-raised text-text-secondary hover:text-text-primary'
          }`}
        >
          {m.label}
        </button>
      ))}
    </div>
  );
}